import { render, staticRenderFns } from "./ac-gantt-chart.vue?vue&type=template&id=b63e7224&"
import script from "./ac-gantt-chart.vue?vue&type=script&lang=js&"
export * from "./ac-gantt-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports